export const passwordRecovery = (translateKey1: string, translateKey2: string) : { [key: string]: any } => {
  return {
    password: {
      length: {
        minimum: 8,
        message: translateKey1,
      },
    },
  
    repeatPassword: {
      equality: {
        attribute: 'password',
        message: translateKey2,
      },
    },
  };
};